// extracted by mini-css-extract-plugin
module.exports = {"title":"logos_title__GMA55","subtitle":"logos_subtitle__ts3ws","logos":"logos_logos__RwO9N"};